const environment = Object.freeze({
   production: true,
   get baseurl() {
      return this.production ? "https://hrm.witmates.com/api/v1" : "http://localhost:3000/api/v1";
   },
});

export default environment;
